import * as angular from "angular";
import {IController} from "angular";

export class IntegrationsViewController implements IController {

  constructor() {}

}

angular
  .module('bringoz.admin.integrations')
  .component('integrationsView', {
    bindings: {},
    template: require('./integrations-view.html').default,
    controller: IntegrationsViewController
  });
